import {
  borderCss,
  boxShadowCss,
  mobileBorderCss,
  mobileBoxShadowCss,
} from 'common/utils/styleUtilsNew'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import styled, { css } from 'styled-components'

type VideoPlaceholderUiProps = BorderEntityInterface & {
  boxShadow?: string
  mobileBoxShadow?: string
}

const VideoPlaceholder = styled.div<VideoPlaceholderUiProps>`
  position: relative;
  padding-bottom: 56.9% !important;
  padding-top: 25px !important;
  overflow: hidden;
  ${borderCss};
  ${boxShadowCss};
  ${p => p.theme.phone} {
    ${mobileBorderCss};
    ${mobileBoxShadowCss};
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileBorderCss};
      ${mobileBoxShadowCss};
    `}
`

export default VideoPlaceholder
